import { useState } from 'react'

const useCreateUnplannedMaintenanceBlankSidePageCtrl = () => {
  const [modalOpen, setModalOpen] = useState(false)

  return {
    open: modalOpen,
    handleClose: () => setModalOpen(false),
    handleOpen: () => setModalOpen(true),
  }
}

export default useCreateUnplannedMaintenanceBlankSidePageCtrl
